import EnvironmentDetection from '../EnvironmentDetection';

export const reloadCurrentLocation = (): void => {
  if (EnvironmentDetection.isBrowser) {
    window.location.reload();
  }
};

export function getFirstParentWithClassName(currentElementId: string, classNameToLookFor: string): HTMLElement | null {
  const elementById = document.getElementById(currentElementId);
  if (elementById) {
    let a: HTMLElement | null = elementById;

    while (a && !a.classList.contains(classNameToLookFor)) {
      a = a.parentElement;
    }
    return a;
  }
  return null;
}

export function getFirstChildWithClassName(currentElementId: string, classNameToLookFor: string): Element | null {
  const elementById = document.getElementById(currentElementId);

  if (elementById) {
    const elementsWithClassName = elementById.getElementsByClassName(classNameToLookFor);
    if (elementsWithClassName && elementsWithClassName.length !== 0) {
      return elementsWithClassName[0];
    }
  }
  return null;
}

export function getComputedStyle(element: HTMLElement): CSSStyleDeclaration | null {
  if (EnvironmentDetection.isBrowser === true) {
    return window.getComputedStyle(element, null);
  }
  return null;
}
